/**
 * A signed tuition agreement the office has changed: what stays as it is, what
 * replaces the remaining payments, and the new total. Signed with the same form
 * as the first agreement (see AgreementStep).
 */
import { ChangeTuitionPayments } from '~/pages/FamilyDetail/ChangeTuitionPayments';
import type { AgreementContext } from '../useChecklistStep';
import { AgreementTerms, AgreementTuition, Section } from './stepParts';

export default function AgreementChange({ agreement }: { agreement: AgreementContext }) {
  return (
    <>
      <Section>
        <h2 className="text-lg font-semibold">{agreement.signed ? 'Your tuition changed' : 'Your tuition is changing'}</h2>
        <ChangeTuitionPayments
          kept={agreement.kept ?? []}
          keptTitle="These stay as they are"
          paymentsTitle="These replace your remaining payments"
          payments={agreement.payments}
        />
      </Section>
      <AgreementTuition agreement={agreement} totalLabel="New total" />
      <AgreementTerms agreement={agreement} />
    </>
  );
}
